import { SvgIcon } from '@avantia/style-guide';
import type { HpSvgIconTypes } from '@avantia/style-guide';

import background from 'assets/images/background-light-blue.png';
import { useGetScreenSize } from 'utils';

import './title.scss';

interface TitleProps {
  title: string;
  icon?: string;
  id?: string;
}

export const Title = ({ title, icon, id = 'default' }: TitleProps): JSX.Element => {
  const { isMobile } = useGetScreenSize();

  return (
    <div className="title">
      <img src={background} height={isMobile ? 120 : 224} className="background" alt="Blue title background"></img>
      <div>
        {icon && <SvgIcon type={icon as HpSvgIconTypes} className="icon" />}
        <h1 className="text" id={`${id}-title`}>
          {title.toLocaleUpperCase()}
        </h1>
      </div>
    </div>
  );
};
